import { FC, ReactNode } from "react";

interface ModalCardProps {
  showModal: boolean;
  children: ReactNode;
}

export const ModalCard: FC<ModalCardProps> = ({ showModal, children }) => {
  return showModal ? (
    <div className="fixed inset-0 bg-black/40 z-[99] flex justify-center items-center">
      {children}
    </div>
  ) : null;
};
